import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import ReceptaclesInPredesNotInPreconReport
  from '../../components/ReceptaclesInPredesNotInPreconReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/ReceptaclesInPredesNotInPreconSummarySelectors';
import ReceptaclesInPredesNotInPreconReportMode from '../../components/ReceptaclesInPredesNotInPreconReportMode';

export class ReceptaclesInPredesNotInPreconSummaryContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportMode: ReceptaclesInPredesNotInPreconReportMode.included,
      showTrafficButton: true,
    };
  }

  changeTrafficMode = () => {
    switch (this.state.reportMode) {
      case ReceptaclesInPredesNotInPreconReportMode.included:
        return this.setState({ reportMode: ReceptaclesInPredesNotInPreconReportMode.excluded });
      case ReceptaclesInPredesNotInPreconReportMode.excluded:
        return this.setState({ reportMode: ReceptaclesInPredesNotInPreconReportMode.included });
      default:
        return (<div id="report-mode-error">Report mode &quot;{this.state.reportMode}&quot; is not implemented</div>);
    }
  };

  renderIncluded() {
    return (
      <ReceptaclesInPredesNotInPreconReport
        reportId={ReportDefinitions.RECEPTACLES_IN_PREDES_NOT_IN_PRECON_SUMMARY.id}
        columns={this.props.columns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data && this.props.data.filter(d => d.isTrafficInternal !== true)}
        showTrafficButton={this.state.showTrafficButton}
        reportMode={ReceptaclesInPredesNotInPreconReportMode.included}
        changeTrafficMode={this.changeTrafficMode}
      />
    );
  }

  renderExcluded() {
    return (
      <ReceptaclesInPredesNotInPreconReport
        reportId={ReportDefinitions.RECEPTACLES_IN_PREDES_NOT_IN_PRECON_SUMMARY.id}
        columns={this.props.columns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        showTrafficButton={this.state.showTrafficButton}
        reportMode={ReceptaclesInPredesNotInPreconReportMode.excluded}
        changeTrafficMode={this.changeTrafficMode}
      />
    );
  }

  render() {
    switch (this.state.reportMode) {
      case ReceptaclesInPredesNotInPreconReportMode.included:
        return this.renderIncluded();
      case ReceptaclesInPredesNotInPreconReportMode.excluded:
        return this.renderExcluded();
      default:
        return (<div id="report-mode-error">Report mode &quot;{this.state.reportMode}&quot; is not implemented</div>);
    }
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

ReceptaclesInPredesNotInPreconSummaryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(ReceptaclesInPredesNotInPreconSummaryContainer);
